import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ITripsOverviewColumn } from '../interfaces';
import LoaderService from '../../../Services/LoaderService';
import TooltipComponent from '../../TooltipComponent';
import MultiSelectFilter from '../Filter/MultiSelectFilter';
import useFilter from '../hooks/useFilter';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { DRIVER_KEY } from '../constants';
import { columnsAtom, rideBookFilterAtom } from '../TripsOverviewState';
import { getDataForFilter } from '../TripsOverviewService';
import useAnalytics from '../../../hooks/useAnalytics';

interface IThDriverProps {
  id: string;
}

function ThDriver(props: IThDriverProps): JSX.Element {
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);
  const [tableActionsFilters, setTableActionsFilters] = useRecoilState(
    rideBookFilterAtom(props.id)
  );
  const { formatMessage: f } = useIntl();
  const { updateFilterItemsState } = useFilter();
  const { trackEvent } = useAnalytics();

  const getFilterData = async () => {
    LoaderService.showLoader(true);
    const dataForFilter = await getDataForFilter(DRIVER_KEY);

    if (dataForFilter) {
      updateFilterItemsState([
        { id: props.id, isOpen: true, isActionChipsOpen: false, data: dataForFilter, values: null },
      ]);

      LoaderService.showLoader(false);
    } else {
      LoaderService.showLoader(false);
    }
  };

  const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    const { id } = event.currentTarget;
    trackEvent(['ride book', 'click', `Ride book open filter ${id}`]);

    setTableActionsFilters(
      (tableActionFilter) =>
        tableActionFilter && {
          ...tableActionFilter,
          id: props.id,
          isOpen: true,
          isActionChipsOpen: false,
        }
    );

    if (id) {
      if (!tableActionsFilters) {
        getFilterData();
      }
    }
  };

  const renderSimpleSelect = (): JSX.Element | null => {
    if (tableActionsFilters && tableActionsFilters.isOpen && tableActionsFilters.data) {
      return (
        <div style={{ position: 'absolute', left: '0', top: '47px' }}>
          <MultiSelectFilter
            id={props.id}
            filterValues={tableActionsFilters.data}
            title={f({ id: 'form.inputs.ridebook.driver' })}
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className={`th-sticky b-table-actions ${
        tableActionsFilters && tableActionsFilters.values ? 'active' : ''
      }`}
      style={{
        minWidth: '120px',
        flex: 1,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'tables.tripsOverview.column.driver',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.driver',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, props.id)}
      >
        <div className="d-flex w-100">
          <div
            id={props.id}
            className="text-truncate"
            onClick={handleOnClick}
            data-cy={`filter-button-text-${props.id}`}
          >
            {f({ id: 'tables.tripsOverview.column.driver' })}
          </div>

          <a
            id={props.id}
            href="#"
            className="filter cmd-icons cmd-icon-filter"
            onClick={handleOnClick}
            data-cy={`filter-button-${props.id}`}
          >
            {/* test */}
          </a>
          <div />
        </div>
      </TooltipComponent>{' '}
      {renderSimpleSelect()}
    </div>
  );
}

export default ThDriver;
